import { spacingFluidMd, spacingFluidXl, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { useIntl } from "react-intl"
import { Grid, GridItem, List } from "src/components"
import { modelInformationMessages } from "./modelInformation.messages"

export interface ModelInformationDetailsProps {
	countryVehicleSpecification?: string
	derivative: string
	driveTrain: string
	engineType: string
	modelGeneration: string
	modelSeries: string
	modelYear: string
	orderTypeName: string
	transmission?: string
}

export const ModelInformationDetails = ({
	countryVehicleSpecification,
	derivative,
	driveTrain,
	engineType,
	modelGeneration,
	modelSeries,
	modelYear,
	orderTypeName,
	transmission,
}: ModelInformationDetailsProps) => {
	const { formatMessage } = useIntl()
	return (
		<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }} $rowGap={spacingStaticSm}>
			<GridItem size={{ base: 12, m: 6 }}>
				<List>
					<List.Item label={formatMessage(modelInformationMessages.modelSeries)} value={modelSeries} />
					<List.Item
						label={formatMessage(modelInformationMessages.modelGeneration)}
						value={modelGeneration}
					/>
					<List.Item label={formatMessage(modelInformationMessages.derivative)} value={derivative} />
					<List.Item label={formatMessage(modelInformationMessages.modelYear)} value={modelYear} />
					<List.Item label={formatMessage(modelInformationMessages.orderType)} value={orderTypeName} />
				</List>
			</GridItem>
			<GridItem size={{ base: 12, m: 6 }}>
				<List>
					<List.Item label={formatMessage(modelInformationMessages.driveTrain)} value={driveTrain} />
					<List.Item label={formatMessage(modelInformationMessages.engineType)} value={engineType} />
					{transmission && (
						<List.Item label={formatMessage(modelInformationMessages.transmission)} value={transmission} />
					)}
					{countryVehicleSpecification && (
						<List.Item
							label={formatMessage(modelInformationMessages.countryVehicleSpecification)}
							value={countryVehicleSpecification}
						/>
					)}
				</List>
			</GridItem>
		</Grid>
	)
}
